<template>
  <div class="about-page">
    <AboutHeader />

    <div class="blog-body" v-if="loaded">
      <div class="blog-featured">
        <img :src="this.featuredImage" :alt="this.title" />
      </div>
      <div class="blog-contents">
        <div class="content-left">
          <div class="blog-author">
            <div class="blog-author-icon">
              <img :src="authorImage" alt="Wotive blog post author">
            </div>
            <div class="blog-author-details">
              <div class="blog-author-name">{{authorName}}</div>
              <div class="blog-author-title">{{authorTitle}}</div>
            </div>
          </div>
          <div class="blog-share">
            <label>Share this post</label>
            
            <div class="share-icon">
              <ShareNetwork
                  role="button"
                  aria-label="Share Facebook"
                  ref="shareNetworkRefF"
                  @open="runWorkaroundF"
                  network="facebook"
                  :url="shareLink"
                  :title="`Wotive: ${title}`"
                  :description="slug"
                >
                <div class="facebook"></div>
              </ShareNetwork>
            </div>
            <div class="share-icon">
              <ShareNetwork
                  role="button"
                  aria-label="Share Twitter"
                  ref="shareNetworkRefT"
                  @open="runWorkaroundT"
                  network="twitter"
                  :url="shareLink"
                  :title="`Wotive: ${title}`"
                  :description="slug"
                >
                <div class="twitter"></div>
              </ShareNetwork>
            </div>
            <div class="share-icon">
              <a aria-label="Share Email" :href="mailToString" target="_blank">
                <div class="email"></div>
              </a>
            </div>
            <div class="share-icon" @click="copyLink()">
              <div class="link"></div>
            </div>
          </div>

          <div class="blog-contents-table">
            <h3>Contents</h3>
            <ul>
              <li v-for="option in tableOfContents" :key="option.title" @click="navigateToSection(option)">
                {{ option.title }}
              </li>
            </ul>
          </div>

          <AboutWotive />
        </div>
        <div class="content-right">
          <div class="blog-title">
            <h1>{{title}}</h1>
            <p>Posted: {{formatDateString(createdAt)}}</p>
          </div>
          <div class="slug">
            {{slug}}
          </div>
          <div class="divider"></div>
          <editor-content :editor="editorBlog" />
          <div class="blog-author mobile-author">
            <div class="blog-author-icon">
              <img :src="authorImage" alt="Wotive blog post author">
            </div>
            <div class="blog-author-details">
              <div class="blog-author-name">{{authorName}}</div>
              <div class="blog-author-title">{{authorTitle}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="blog-share mobile-share">
            <label>Share this post</label>
            
            <div>
              <div class="share-icon">
                <ShareNetwork
                    role="button"
                    aria-label="Share Facebook"
                    ref="shareNetworkRefF"
                    @open="runWorkaroundF"
                    network="facebook"
                    :url="shareLink"
                    :title="`Wotive: ${title}`"
                    :description="slug"
                  >
                  <div class="facebook"></div>
                </ShareNetwork>
              </div>
              <div class="share-icon">
                <ShareNetwork
                    role="button"
                    aria-label="Share Twitter"
                    ref="shareNetworkRefT"
                    @open="runWorkaroundT"
                    network="twitter"
                    :url="shareLink"
                    :title="`Wotive: ${title}`"
                    :description="slug"
                  >
                  <div class="twitter"></div>
                </ShareNetwork>
              </div>
              <div class="share-icon">
                <a aria-label="Share Email" :href="mailToString" target="_blank">
                  <div class="email"></div>
                </a>
              </div>
              <div class="share-icon" @click="copyLink()">
                <div class="link"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading" v-else></div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AboutHeader from '@/components/header/AboutHeader.vue';
import AboutWotive from '@/components/blog/AboutWotive.vue';
import { Editor, EditorContent } from 'tiptap';
import { getBlog } from '@/api/requests';
import TocHeading from '@/components/content_editor/TocHeading.js';
import {
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Strike,
  Underline,
  Image,
  Link,
} from 'tiptap-extensions';
import TimeAgo from 'javascript-time-ago';
import { formatDate } from '@/utils';

export default {
  name: 'BlogPage',

  data() {
    return {
      showSmallMenu: false,
      contents: '',
      editorBlog: null,
      createdAt: '',
      featuredImage: '',
      title: '',
      slug: '',
      authorName: '',
      authorTitle: '',
      authorImage: '',
      loaded: false,
      tableOfContents: [],
    };
  },

  components: {
    Footer,
    EditorContent,
    AboutHeader,
    AboutWotive,
  },

  mounted() {
    window.scrollTo(0,0);

    const blogUrlName = this.$route.params.id;
    getBlog(blogUrlName).then(response => {
      let data = response.data[0];
      this.featuredImage = this.url + data.featured_image;
      this.title = data.title;
      this.slug = data.slug;
      this.authorName = data.author.name;
      this.authorTitle = data.author.title;
      this.authorImage = this.url + data.author.image;
      let stringBody = data.content;
      this.createdAt = data.created_at;
      this.contents = JSON.parse(stringBody);
      let contents = this.getBlogContents();
      this.editorBlog = new Editor({
        editorProps: {
          attributes: {
            class: 'pm-output-mode',
          },
        },
        editable: false,
        content: contents['blog'],
        extensions: [
          new BulletList(),
          new TocHeading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
          new Link(),
        ],
      });
      this.loaded = true;
    }).catch(() => {
      // TODO errors
    });

    setTimeout(() => {
      this.$nextTick(function () {
        const h1Elements = document.getElementsByClassName('ProseMirror')[0].querySelectorAll("h1");
        h1Elements.forEach(h1 => {
          this.tableOfContents.push({
            'title': h1.outerText,
            'id': h1.id,
          });
        });
      });
    }, 1000);
  },

  methods: {
    formatDateString(date) {
      return formatDate(date);
    },
    
    runWorkaroundF(index) {
      if (!this.$refs.shareNetworkRefF.value) return;

      clearInterval(this.$refs.shareNetworkRefF.value.popupInterval);
      this.$refs.shareNetworkRefF.value.popupWindow = undefined;
    },

    runWorkaroundT(index) {
      if (!this.$refs.shareNetworkRefT.value) return;

      clearInterval(this.$refs.shareNetworkRefT.value.popupInterval);
      this.$refs.shareNetworkRefT.value.popupWindow = undefined;
    },

    getBlogContents() {
      let blogContents = [];
      for (let i = 0; i < this.contents['content'].length; i++) {
        let currentContent = this.contents['content'][i];
        blogContents.push(currentContent);
      }

      return { 
        'blog': {'type': 'doc', 'content': blogContents },
      };
    },

    calculateTimeago(lastDate) {
      if (lastDate) {
        const date = new Date(lastDate.split(' +')[0]);
        const timeAgo = new TimeAgo('en-US')
        return timeAgo.format(date, 'mini') + ' ago';
      }
      return '-';
    },

    navigateToSection(option) {
      const elem = document.getElementById(option.id);
      elem.scrollIntoView({ behavior: 'smooth' });
    },

    async copyLink() {
      await navigator.clipboard.writeText(this.shareLink);
      this.$toasted.global.app_success({
        message: "Link has been copied to your clipboard!"
      });
    }
  },

  computed: {
    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    shareLink() {
      return window.location.href;
    },

    mailToString()
    {
      const subject = "Wotive: " + this.title;
      const body = "Check out this blog by Wotive - " + this.shareLink;
      return "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/css/variables";
.pm-output-mode {
  color: $sec1;

  img {
    width: 100%;
    border-radius: 8px;
  }

  h1 {
    font-weight: 500;
    font-size: 24px;
    color: $sec1;
    margin-top: 40px;
    // text-transform: uppercase;
  }

  h2 {
    font-weight: 500;
    font-size: 24px;
    color: $sec1;
    margin-top: 16px;
  }

  h3 {
    font-weight: 500;
    font-size: 20px;
    color: $sec1;
    margin-top: 16px;
  }

  a {
    // text-decoration: none;
    color: $blue;

    &:hover {
      text-decoration: underline;
    }
  }
}

.blog-page {
  background: #F4F7FA;
}

.blog-body {
  max-width: 1080px;
  margin: auto;
}

.blog-featured {
  aspect-ratio: 2 / 1;
  width: 100%;
  overflow: hidden;

  img {
    width: 100%;
    object-fit: cover;
  }
}

.blog-contents {
  display: block;
  column-gap: 40px;
  grid-template-columns: 250px auto;
  margin-bottom: $spacing-large;

  .content-left {
    display: none;
    width: 100%;
    .blog-cta {
      display: none;
    }

    .blog-author {
      justify-self: flex-end;
      display: flex;
      align-items: center;
      float: left;
      .blog-author-icon {
        width: 40px;
        height: 40px;
        border-radius: 40px;
        background: #CCC;
        margin-right: $spacing-small;
        font-size: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 40px;
        }
      }
      .blog-author-details {
        .blog-author-name {
          font-weight: bold;
          color: $sec1;
        }
        .blog-author-title {
          font-weight: normal;
          margin-top: 2px;
          color: $sec3;
        }
      }
    }

    .blog-share {
      float: right;
      label {
        font-weight: 500;
        display: block;
      }
      
      .share-icon {
        height: 24px;
        width: 24px;
        padding: 5px 4px;
        display: inline-block;
        margin-top: 8px;

        &:first-of-type {
          padding-left: 0;
        }
      }
      .facebook {
        background-image: url(~@/assets/socials/facebook.svg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
      }
      .twitter {
        background-image: url(~@/assets/socials/x.svg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 18px;
        margin-top: 3px;
      }
      .email {
        background-image: url(~@/assets/socials/email.svg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
      }
      .link {
        background-image: url(~@/assets/socials/link.svg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
      }
    }

    .blog-contents-table {
      margin-top: 20px;
      clear: both;
      ul {
        padding: 0;
        li {
          list-style: none;
          padding: 10px 5px;
        }
        li:hover {
          cursor: pointer;
          background: $sec7;
        }
      }
    }
  }
  .content-right {
    padding: 16px;
    .blog-title {
      h1 {
        font-size: 36px;
        color: $sec0;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0;
        margin: 0;
      }
      
      p {
        color: $sec2;
        font-size: 18px;
        margin-top: 8px;
        margin-bottom: 8px;
      }
    }

    .slug {
      padding-bottom: $spacing-large*1.5;
      line-height: 1.75rem;
      font-size: 16px;
      color: $sec2;
    }

    .divider {
      margin-bottom: 40px;
    }

    p {
      line-height: 1.75rem;
      font-size: 1.125rem;
      color: $sec2;
    }
  }
}

.divider {
  background-image: url(~@/assets/landing-page/divider.webp);
  max-width: 1200px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 40px;
}

.blog-author {
  justify-self: flex-end;
  display: flex;
  align-items: center;
  .blog-author-icon {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: #CCC;
    margin-right: $spacing-small;
    font-size: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 40px;
    }
  }
  .blog-author-details {
    .blog-author-name {
      font-weight: bold;
      color: $sec1;
    }
    .blog-author-title {
      font-weight: normal;
      margin-top: 2px;
      color: $sec3;
    }
  }
}

.blog-share {
  justify-content: center;
  label {
    font-weight: 500;
    display: block;
  }
  
  .share-icon {
    height: 24px;
    width: 24px;
    padding: 5px 4px;
    display: inline-block;
    margin-top: 8px;

    &:first-of-type {
      padding-left: 0;
    }
  }
  .facebook {
    background-image: url(~@/assets/socials/facebook.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
  }
  .twitter {
    background-image: url(~@/assets/socials/x.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 18px;
    margin-top: 3px;
  }
  .email {
    background-image: url(~@/assets/socials/email.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
  }
  .link {
    background-image: url(~@/assets/socials/link.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
  }
}

.mobile-share {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media all and (min-width: 1000px) {
  .pm-output-mode {
    h1 {
      font-size: 36px;
    }

    p {
      font-size: 14px;
    }
  }
  .blog-featured {
    margin-bottom: 64px;
    border-radius: 8px;
  }
  .blog-contents {
    display: grid;

    .content-left {
      width: 250px;
      height: 400px;
      position: sticky;
      top: 20px;
      display: block;

      .blog-author {
        float: none;
      }

      .blog-share {
        float: none;
        margin-top: $spacing-large;
      }

      .blog-cta {
        display: block;
      }
    }

    .content-right {
      padding: 0;

      .blog-title h1 {
        font-size: 48px;
      }
    }
  }
  .blog-body {
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .content-left {
    display: block;
  }
  .mobile-share {
    display: none;
  }
  .mobile-author {
    display: none;
  }
}
</style>